import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { currencyValue } from "utils/common";
import { getBulkQuoteData, getPrcList } from "store/priceQuote/actionCreator";
import { getUniqueQuoteData } from "../utils";
import toast_error from "svg/toast_error.svg";
import { toast } from "react-toastify";
import Button from "react-bootstrap/Button";
import InputField from "common/customInputField";
import quoteImg from "svg/quote.svg";
import info from "svg/info.svg";
import CustomTooltip from "common/tooltip";
import Confirmation from "./confirmation";
import { api } from "store/slices/api";
import "./style.scss";

const UpdatePrc = () => {
  const { quoteId } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { bulkPricesQuoteData, prcList } = useSelector((state) => state.priceQuote);
  const { fcRole, terrCcn, sub, storeCcn } = useSelector((state) => state.loggedInUser);
  const [productsData, setProductsData] = useState();
  const [prcType, setPrcType] = useState("update");
  const [prcTypeValid, setPrcTypeValid] = useState("");
  const [prcDescValid, setPrcDescValid] = useState("");
  const [stage, setStage] = useState("prc");
  const [prcDesc, setPrcDesc] = useState();
  const [successModal, setSuccessModal] = useState(false);
  const [isSelectAllCheckedProducts, setIsSelectAllCheckedProducts] = useState(true);
  const [prcDets, setPrcDets] = useState();
  const [allProductList, setAllProductList] = useState();
  const [alertNotification, setAlertNotification] = useState(false);
  const [prcLoading, setLoading] = useState(false);
  const [warningMsg, setWarningMessage] = useState("");
  const { data: quote = {} } = api.useGetPriceQuoteQuery(quoteId);
  const [updatePRC] = api.useDeprecatedUpdatePRCMutation();
  const [createPRC] = api.useDeprecatedCreatePRCMutation();

  useEffect(() => {
    let payload = { acctNbr: quote.accountNumber, jobNbr: quote.jobNumber };
    dispatch(getPrcList(payload)).then(() => {
      setLoading(true);
    });
  }, []);

  useEffect(() => {
    if (!quote.prcNumber && prcLoading) {
      setPrcType("create");
      if (!(prcList?.length > 0)) {
        setPrcDesc("Main Account");
        setWarningMessage("The description must be Main Account for the first PRC on an account.");
      }
    }
  }, [prcList, prcLoading]);

  useEffect(() => {
    let payload = { quoteId, acctNbr: quote?.accountNumber, prcNbr: quote?.prcNumber, jobNumber: quote?.jobNumber };
    dispatch(getBulkQuoteData(payload)).then((res) => {
      const { uniqueProducts } = getUniqueQuoteData(res);
      setAllProductList(uniqueProducts);
    });
  }, [quoteId, quote?.accountNumber, quote?.prcNumber, quote?.jobNumber]);

  useEffect(() => {
    if (allProductList) {
      const tempProducts = JSON.parse(JSON.stringify(allProductList));
      if (prcType === "update") {
        tempProducts.map((ele) => {
          if (!ele.salesNumber || ele.price === 0 || parseFloat(ele.price) === parseFloat(ele.prcPrice)) {
            ele.isProductSelected = false;
            ele.isProductDisabled = true;
          } else {
            ele.isProductSelected = true;
            ele.isProductDisabled = false;
          }
        });
      } else if (prcType === "create") {
        tempProducts.map((ele) => {
          if (!ele.salesNumber || ele.price === 0) {
            ele.prcPrice = "0.00";
            ele.isProductSelected = false;
            ele.isProductDisabled = true;
          } else {
            ele.prcPrice = "0.00";
            ele.isProductSelected = true;
            ele.isProductDisabled = false;
          }
        });
      }

      const tempSortProductitems = [...tempProducts].sort((a, b) => {
        if (!a.isProductDisabled && b.isProductDisabled) {
          return -1;
        } else if (a.isProductDisabled && !b.isProductDisabled) {
          return 1;
        } else {
          return 0;
        }
      });
      setProductsData(tempSortProductitems);
    }
  }, [allProductList, prcType]);

  useEffect(() => {
    if (productsData?.length && productsData?.every((ele) => ele.isProductDisabled === true)) {
      setAlertNotification(true);
    } else {
      setAlertNotification(false);
    }
  }, [productsData, prcType]);

  const handleSummaryPage = () => {
    navigate(`/priceQuote/${quoteId}#quote-summary`);
  };

  const handleConfirmationPage = () => {
    let flag = true;
    if (productsData?.some((ele) => ele.isProductSelected === true)) {
      flag = false;
    }
    if (!quote.accountNumber || !quote.jobNumber) {
      toast.error("Must have an account and Job on the quote to proceed");
    } else if (prcType === "update" && !quote.prcNumber) {
      toast.error("You must add a PRC to this quote in order to update it or create a new PRC.");
    } else if (flag) {
      toast.error("Please select at least one product to proceed");
    } else {
      let valid = true;
      setPrcTypeValid("");
      setPrcDescValid("");
      if (!prcType || prcType === "") {
        valid = false;
        setPrcTypeValid("Please select an option");
      } else if (prcType === "create" && !prcDesc) {
        valid = false;
        setPrcDescValid("Please enter Description");
      } else if (prcType === "create" && prcDesc && prcDesc.length > 30) {
        valid = false;
        setPrcDescValid("Please enter maximum of 30 characters");
      }

      if (valid) {
        setStage("confirmation");
      }
    }
  };

  const confirmPrcUpdate = () => {
    let quoteData = JSON.parse(JSON.stringify(bulkPricesQuoteData));
    let productsList = [];
    quoteData.productDtoList.map((ele) => {
      productsData.map((prod) => {
        if (prod.isProductSelected) {
          if (
            ((prod.salesNumber && ele.salesNumber && prod.salesNumber === ele.salesNumber) ||
              prod.productName === ele.productName) &&
            !productsList.includes(ele)
          ) {
            let tempData = {
              salesNbr: ele.salesNumber,
              originalPrice: ele.prcPrice,
              xcptPr: ele.price,
              quoteLineId: ele.productId,
            };
            var contains = productsList.some((elem) => {
              return JSON.stringify(tempData) === JSON.stringify(elem);
            });
            if (!contains) {
              productsList.push(tempData);
            }
          }
        }
      });
    });
    if (prcType === "update") {
      let updatePayload = {
        acctNbr: quote.accountNumber,
        prcDtl3: productsList,
        jobNbr: quote.jobNumber,
        prcNbr: quote.prcNumber,
        quote: quoteId,
        userId: sub,
        userRole: fcRole,
        storeCcn: storeCcn,
        terrCcn: terrCcn,
      };
      updatePRC(updatePayload).then((res) => {
        if (res) {
          setSuccessModal(true);
        }
      });
    } else if (prcType === "create") {
      let payload = {
        acctNbr: quote.accountNumber,
        prcDtl3: productsList,
        jobNbr: quote.jobNumber,
        descr: prcDesc,
        quote: quoteId,
        userId: sub,
        userRole: fcRole,
        storeCcn: storeCcn,
        terrCcn: terrCcn,
      };
      createPRC(payload).then((res) => {
        if (res.error) {
          const externalSystemError = res.error?.data?.topLevelStatusMessage?.toString();
          if (externalSystemError?.includes("MAIN ACCOUNT") && payload.descr !== "Main Account") {
            createPRC({ ...payload, descr: "Main Account" }).then((retryRes) => {
              if (retryRes.data) {
                setSuccessModal(true);
                setPrcDets(retryRes.data);
              }
            });
          } else {
            toast.error(externalSystemError ?? "Could not create PRC. Please try again.");
          }
        } else if (res.data) {
          setSuccessModal(true);
          setPrcDets(res.data);
        }
      });
    }
  };

  const quotePriceCalculation = (quotePrice, prcPrice) => {
    let color = "";
    let percentVal = 5;
    if (quotePrice > prcPrice) {
      color = "approved-dot";
    } else {
      const percentage = ((parseFloat(prcPrice) - parseFloat(quotePrice)) / parseFloat(quotePrice)) * 100;
      if (percentage < percentVal) {
        color = "pending-dot";
      }
      if (percentage > percentVal) {
        color = "reject-dot";
      }
    }
    return color;
  };

  const onProductSelection = (productId) => {
    const productsDataNew = JSON.parse(JSON.stringify(productsData));
    productsDataNew.map((item) => {
      if (item.productId === productId) {
        item.isProductSelected = item.isProductSelected ? false : true;
      }
    });

    let isAllProductChecked = isSelectAllCheckedProducts;
    if (productsDataNew?.some((ele) => ele.isProductSelected === false)) {
      isAllProductChecked = false;
    }
    setIsSelectAllCheckedProducts(isAllProductChecked);
    setProductsData(productsDataNew);
  };

  const handlePrcType = (e) => {
    const value = e.target.value;
    if (value === "update") {
      setPrcType("update");
    } else if (value === "create") {
      setPrcType("create");
    }
  };

  const handlePrcDesc = (e) => {
    const value = e.target.value;
    setPrcDesc(value);
    if (prcType === "create" && value.length > 30) {
      setPrcDescValid("Please enter maximum of 30 characters");
    } else {
      setPrcDescValid("");
    }
  };

  const handleSelectAllProducts = () => {
    let isAllProductChecked = isSelectAllCheckedProducts;
    const tempProductsData = JSON.parse(JSON.stringify(productsData));

    if (isSelectAllCheckedProducts) {
      tempProductsData.map((data) => {
        data.isProductSelected = false;
      });
      isAllProductChecked = false;
    } else {
      tempProductsData.map((data) => {
        if (!(!data.salesNumber || data.price === 0 || parseFloat(data.price) === parseFloat(data.prcPrice))) {
          data.isProductSelected = true;
        }
      });
      isAllProductChecked = true;
    }
    setProductsData(tempProductsData);
    setIsSelectAllCheckedProducts(isAllProductChecked);
  };

  const getRelatedMsg = (data) => {
    if (
      !data.salesNumber &&
      parseFloat(data.prcPrice) === parseFloat(data.price) &&
      parseFloat(data.price) === parseFloat("0")
    ) {
      return `Missing Sales Number, Quote Price Matches PRC Price and Quote Price is $0.00`;
    }
    if (
      !data.salesNumber &&
      parseFloat(data.prcPrice) === parseFloat(data.price) &&
      !(parseFloat(data.price) === parseFloat("0"))
    ) {
      return `Missing Sales Number and Quote Price Matches PRC Price`;
    }
    if (
      data.salesNumber &&
      parseFloat(data.prcPrice) === parseFloat(data.price) &&
      parseFloat(data.price) === parseFloat("0")
    ) {
      return `Quote Price Matches PRC Price and Quote Price is $0.00`;
    }
    if (
      data.salesNumber &&
      !(parseFloat(data.prcPrice) === parseFloat(data.price)) &&
      parseFloat(data.price) === parseFloat("0")
    ) {
      return `Missing Sales Number and Quote Price is $0.00`;
    }
    if (
      !data.salesNumber &&
      !(parseFloat(data.prcPrice) === parseFloat(data.price)) &&
      !(parseFloat(data.price) === parseFloat("0"))
    ) {
      return `Missing Sales Number`;
    }
    if (
      data.salesNumber &&
      parseFloat(data.prcPrice) === parseFloat(data.price) &&
      !(parseFloat(data.price) === parseFloat("0"))
    ) {
      return `Quote Price Matches PRC Price`;
    }
    if (
      data.salesNumber &&
      !(parseFloat(data.prcPrice) === parseFloat(data.price)) &&
      parseFloat(data.price) === parseFloat("0")
    ) {
      return `Quote Price is $0.00`;
    }
  };

  return (
    <>
      {stage === "prc" && (
        <div className="container-fluid search-form-container">
          <div className="search-form-container__title">
            <span className="search-form-container__title--text">
              <img src={quoteImg} alt="quote" />
              &nbsp;Update PRC
            </span>
          </div>

          <div className="d-md-flex flex-column flex-md-row mt-md-5 mb-5 overflow-auto position-relative spacing">
            <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
              <div className="info-item__label">Account</div>
              <div className="info-item__value text-end text-md-start">
                {!quote.accountNumber ? "N/A" : `${quote.accountNumber} - ${quote.accountName}`}
              </div>
            </div>
            <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
              <div className="info-item__label">Job</div>
              <div className="info-item__value text-end text-md-start">
                {!quote.jobNumber ? "N/A" : `${quote.jobNumber} : ${quote.jobName}`}
              </div>
            </div>
            <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start col-12 col-md-3">
              <div className="info-item__label">PRC</div>
              <div className="info-item__value text-end text-md-start">
                {!quote.prcNumber ? "N/A" : `${quote.prcNumber} : ${quote.prcDesc}`}
              </div>
            </div>
          </div>

          <div className="col-12">
            <p className="radio__instruction px-0">
              {prcType === "update"
                ? `You are about to update PRC ${
                    !quote.prcNumber || quote.prcNumber === ": -- Select value --"
                      ? ""
                      : quote.prcNumber + ": " + quote.prcDesc
                  }`
                : `You are about to create a new PRC for Job ${quote.jobNumber} : ${quote.jobName}`}
            </p>
          </div>
          <div className="row">
            <div className="col-12 col-sm-12 col-md-6 col-lg-3 search-form-container__fields__form-group">
              <input
                type="radio"
                name="type"
                value="update"
                onChange={handlePrcType}
                className="radioBtn"
                checked={prcType === "update"}
              />
              <label htmlFor="manual" className="radioBtntxt">
                Update PRC
              </label>
            </div>
            <div className="col-12 col-sm-12 col-md-6 col-lg-3 search-form-container__fields__form-group">
              <input
                type="radio"
                name="type"
                value="create"
                onChange={handlePrcType}
                className="radioBtn"
                checked={prcType === "create"}
              />
              <label htmlFor="default" className="radioBtntxt">
                Create New PRC
              </label>
            </div>
            {prcTypeValid && <span className="error-text">{prcTypeValid}</span>}
          </div>

          {prcType === "create" && (
            <div className="row">
              <div className="col-12 col-sm-12 col-md-6 col-lg-5 search-form-container__fields__form-group">
                <InputField
                  type="text"
                  label="PRC Description"
                  id="prcDesc"
                  placeholder="Enter PRC Description"
                  fieldClasses="form-control search-form-container__fields__form-group__item"
                  value={prcDesc}
                  onChange={handlePrcDesc}
                  disabled={false}
                  isRequired={false}
                  errorMsg={prcDescValid}
                />
              </div>
            </div>
          )}

          {warningMsg && (
            <div className="form-group">
              <div className="error-etext error-errStyle search-form-container__fields__msg--text w-100 m-0 mb-3">
                {warningMsg}
              </div>
            </div>
          )}

          {alertNotification && (
            <div className="alert-msg alert-danger d-flex align-items-center" role="alert">
              <img src={toast_error} />
              &nbsp;<div>No products are selectable</div>
            </div>
          )}

          <div className="d-flex justify-content-between">
            <div className="flex-grow-1">
              <div className="prod-header prc-sizing">Material Items</div>
              <div className={alertNotification ? "no-inputsty d-flex col-12" : "d-flex col-12"}>
                <div className={`d-flex col-lg-2 col-md-4 align-items-center`}>
                  {!alertNotification && (
                    <>
                      <span className="checkbox-prc-label">
                        <input
                          type="checkbox"
                          aria-label="Checkbox select all of rows"
                          className="checkbox-prc--input"
                          checked={isSelectAllCheckedProducts}
                          onChange={handleSelectAllProducts}
                        />
                      </span>
                      <span className="checkbox-prc-text-input">Select All</span>
                    </>
                  )}
                </div>
              </div>
            </div>

            <div className="d-flex justify-content-end info-container">
              <table className="info-table">
                <tbody>
                  <tr>
                    <td className="td-header">
                      <div className="dotstyle approved-dot">&#11044;</div>
                    </td>
                    <td className="td-info">Price Increase</td>
                  </tr>
                  <tr>
                    <td className="td-header">
                      <div className="dotstyle pending-dot">&#11044;</div>
                    </td>
                    <td className="td-info">Price decrease up to 5%</td>
                  </tr>
                  <tr>
                    <td className="td-header">
                      <div className="dotstyle reject-dot">&#11044;</div>
                    </td>
                    <td className="td-info">Price decrease over 5%</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {productsData?.map((data, index) => {
            return (
              <div className="bulkUpdateQuote_container" key={index + data.productName}>
                <div className="row bulkUpdateQuote_container__floor_area">
                  <div className="d-md-flex flex-column flex-md-row overflow-auto position-relative">
                    <div className="d-flex flex-row flex-md-column justify-content-between justify-content-md-start check_box-width">
                      {!data.isProductDisabled ? (
                        <input
                          type="checkbox"
                          className="update-prc-checkbox"
                          onChange={() => onProductSelection(data.productId)}
                          checked={data.isProductSelected}
                          disabled={data.isProductDisabled}
                        />
                      ) : (
                        <CustomTooltip placement="top" trigger="hover" text={getRelatedMsg(data)}>
                          <img src={info} alt="info" className="infoIcon" />
                        </CustomTooltip>
                      )}
                    </div>
                    <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start sales-width">
                      <div className="info-item__label">Sales Number</div>
                      <div className="info-item__value text-end text-md-start">
                        {!data.salesNumber ? "N/A" : data.salesNumber}
                      </div>
                    </div>
                    <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start prod-width">
                      <div className="info-item__label">Product Name</div>
                      <div className="info-item__value text-end text-md-start prod-name">{data.productName}</div>
                    </div>
                    <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start category-width">
                      <div className="info-item__label">Category</div>
                      <div className="info-item__value text-end text-md-start">{data.category}</div>
                    </div>
                    <div className="d-flex flex-row flex-md-column info-item justify-content-between justify-content-md-start prc-width">
                      <div className="info-item__label text-md-end">PRC Price</div>
                      <div className="info-item__value text-end text-md-end">{currencyValue(data.prcPrice)}</div>
                    </div>
                    <div className="d-flex flex-row flex-md-column info-item-price justify-content-between justify-content-md-start price-width">
                      <div className="info-item__label text-md-end">Quote Price</div>
                      <div className="info-item__value text-end text-md-end">{currencyValue(data.price)}</div>
                    </div>
                    <div className="d-flex flex-row flex-md-column info-item justify-content-between dot-width">
                      <div></div>
                      <div className="info-item__value text-start text-md-start">
                        {currencyValue(data.price) !== currencyValue(data.prcPrice) && (
                          <div className={`dotstyle ${quotePriceCalculation(data.price, data.prcPrice)}`}>&#11044;</div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}

          <div className="d-flex justify-content-between flex-column flex-md-row mt-10 footer-spacing">
            <Button variant="outline-primary" onClick={handleSummaryPage}>
              Back
            </Button>
            <Button variant="primary" onClick={handleConfirmationPage} disabled={alertNotification}>
              Next
            </Button>
          </div>
        </div>
      )}

      {stage === "confirmation" && (
        <Confirmation
          confirmPrcUpdate={confirmPrcUpdate}
          productsData={productsData}
          quoteFields={quote}
          setStage={setStage}
          prcType={prcType}
          prcDesc={prcDesc}
          quotePriceCalculation={quotePriceCalculation}
          setSuccessModal={setSuccessModal}
          successModal={successModal}
          prcDets={prcDets}
        />
      )}
    </>
  );
};

export default UpdatePrc;
